// Generated by purs version 0.13.8
"use strict";
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Tutorial = require("../Lunarbox.Data.Tutorial/index.js");
var Routing_Duplex = require("../Routing.Duplex/index.js");
var Routing_Duplex_Generic = require("../Routing.Duplex.Generic/index.js");
var Routing_Duplex_Generic_Syntax = require("../Routing.Duplex.Generic.Syntax/index.js");
var Home = (function () {
    function Home() {

    };
    Home.value = new Home();
    return Home;
})();
var Login = (function () {
    function Login() {

    };
    Login.value = new Login();
    return Login;
})();
var Register = (function () {
    function Register() {

    };
    Register.value = new Register();
    return Register;
})();
var Projects = (function () {
    function Projects() {

    };
    Projects.value = new Projects();
    return Projects;
})();
var Project = (function () {
    function Project(value0) {
        this.value0 = value0;
    };
    Project.create = function (value0) {
        return new Project(value0);
    };
    return Project;
})();
var EditTutorial = (function () {
    function EditTutorial(value0) {
        this.value0 = value0;
    };
    EditTutorial.create = function (value0) {
        return new EditTutorial(value0);
    };
    return EditTutorial;
})();
var Tutorial = (function () {
    function Tutorial(value0) {
        this.value0 = value0;
    };
    Tutorial.create = function (value0) {
        return new Tutorial(value0);
    };
    return Tutorial;
})();
var Clone = (function () {
    function Clone(value0) {
        this.value0 = value0;
    };
    Clone.create = function (value0) {
        return new Clone(value0);
    };
    return Clone;
})();
var tutorialId = Routing_Duplex.as(Data_Show.show(Lunarbox_Data_Tutorial.showTutorialId))((function () {
    var $92 = Data_Functor.map(Data_Either.functorEither)(Lunarbox_Data_Tutorial.TutorialId);
    var $93 = Data_Either.note("Cannot parse tutorial id");
    return function ($94) {
        return $92($93(Data_Int.fromString($94)));
    };
})());
var projectId = Routing_Duplex.as(Data_Show.show(Lunarbox_Data_ProjectId.showProjectId))((function () {
    var $95 = Data_Functor.map(Data_Either.functorEither)(Lunarbox_Data_ProjectId.ProjectId);
    var $96 = Data_Either.note("Cannot parse project id");
    return function ($97) {
        return $95($96(Data_Int.fromString($97)));
    };
})());
var genericRoute = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Home) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Login) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof Register) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof Projects) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
    };
    if (x instanceof Project) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
    };
    if (x instanceof EditTutorial) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof Tutorial) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
    };
    if (x instanceof Clone) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Route (line 29, column 1 - line 29, column 48): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Home.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Login.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return Register.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return Projects.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new Project(x.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new EditTutorial(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return new Tutorial(x.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))) {
        return new Clone(x.value0.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Route (line 29, column 1 - line 29, column 48): " + [ x.constructor.name ]);
});
var routingCodec = Routing_Duplex.root(Routing_Duplex_Generic.sum(genericRoute)(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Home";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Login";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Register";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Projects";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Project";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "EditTutorial";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Tutorial";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Clone";
}))()(Routing_Duplex_Generic.gRouteArgument)))))))))({
    Home: Routing_Duplex_Generic.noArgs,
    Login: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("login")(Routing_Duplex_Generic.noArgs),
    Register: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("register")(Routing_Duplex_Generic.noArgs),
    Projects: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("projects")(Routing_Duplex_Generic.noArgs),
    EditTutorial: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteArgument))("edit")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("tutorial")(tutorialId(Routing_Duplex.segment))),
    Project: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteArgument))("edit")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("project")(projectId(Routing_Duplex.segment))),
    Tutorial: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteArgument))("go")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("tutorial")(tutorialId(Routing_Duplex.segment))),
    Clone: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteArgument))("go")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("project")(projectId(Routing_Duplex.segment)))
}));
var parseRoute = Routing_Duplex.parse(routingCodec);
var showRoute = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericRoute)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Home";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Login";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Register";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Projects";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_ProjectId.showProjectId))(new Data_Symbol.IsSymbol(function () {
    return "Project";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Tutorial.showTutorialId))(new Data_Symbol.IsSymbol(function () {
    return "EditTutorial";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Tutorial.showTutorialId))(new Data_Symbol.IsSymbol(function () {
    return "Tutorial";
})))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_ProjectId.showProjectId))(new Data_Symbol.IsSymbol(function () {
    return "Clone";
})))))))))));
var eqRoute = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Home && y instanceof Home) {
            return true;
        };
        if (x instanceof Login && y instanceof Login) {
            return true;
        };
        if (x instanceof Register && y instanceof Register) {
            return true;
        };
        if (x instanceof Projects && y instanceof Projects) {
            return true;
        };
        if (x instanceof Project && y instanceof Project) {
            return Data_Eq.eq(Lunarbox_Data_ProjectId.eqProjectId)(x.value0)(y.value0);
        };
        if (x instanceof EditTutorial && y instanceof EditTutorial) {
            return Data_Eq.eq(Lunarbox_Data_Tutorial.eqTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof Tutorial && y instanceof Tutorial) {
            return Data_Eq.eq(Lunarbox_Data_Tutorial.eqTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof Clone && y instanceof Clone) {
            return Data_Eq.eq(Lunarbox_Data_ProjectId.eqProjectId)(x.value0)(y.value0);
        };
        return false;
    };
});
var ordRoute = new Data_Ord.Ord(function () {
    return eqRoute;
}, function (x) {
    return function (y) {
        if (x instanceof Home && y instanceof Home) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Home) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Home) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Login && y instanceof Login) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Login) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Login) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Register && y instanceof Register) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Register) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Register) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Projects && y instanceof Projects) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Projects) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Projects) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Project && y instanceof Project) {
            return Data_Ord.compare(Lunarbox_Data_ProjectId.ordProjectID)(x.value0)(y.value0);
        };
        if (x instanceof Project) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Project) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof EditTutorial && y instanceof EditTutorial) {
            return Data_Ord.compare(Lunarbox_Data_Tutorial.ordTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof EditTutorial) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof EditTutorial) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Tutorial && y instanceof Tutorial) {
            return Data_Ord.compare(Lunarbox_Data_Tutorial.ordTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof Tutorial) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Tutorial) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Clone && y instanceof Clone) {
            return Data_Ord.compare(Lunarbox_Data_ProjectId.ordProjectID)(x.value0)(y.value0);
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Route (line 27, column 1 - line 27, column 38): " + [ x.constructor.name, y.constructor.name ]);
    };
});
module.exports = {
    Home: Home,
    Login: Login,
    Register: Register,
    Projects: Projects,
    Project: Project,
    EditTutorial: EditTutorial,
    Tutorial: Tutorial,
    Clone: Clone,
    routingCodec: routingCodec,
    projectId: projectId,
    tutorialId: tutorialId,
    parseRoute: parseRoute,
    eqRoute: eqRoute,
    ordRoute: ordRoute,
    genericRoute: genericRoute,
    showRoute: showRoute
};
